export function showAllManuals(e){
  e.currentTarget.parentElement.previousElementSibling.querySelectorAll('a[aria-hidden="true"]').forEach(i=>i.ariaHidden = false);
  e.currentTarget.disabled = true;
}